import { useI18n } from 'vue-i18n';

import useMeta from '~coreModules/core/js/seo/composables/use-meta';

import { getRobots } from '~coreModules/core/js/seo/meta-utils';

export default function useAccountMeta() {
    const { t } = useI18n();

    function getMetaTags() {
        const noIndex = true;
        const noFollow = true;

        return [{
            name: 'robots',
            content: getRobots(noIndex, noFollow),
        }, {
            property: 'og:title',
            content: t('meta__account--title'),
        }, {
            property: 'og:description',
            content: t('meta__account--description'),
        }];
    }

    function getPageTitle() {
        return t('meta__account--title');
    }

    useMeta({ getMetaTags, getPageTitle });
}
